<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Məsafə və yanacaq sərfi</h1>
      </div>

      <div class="col-md-6">
        <p>Haradan:</p>
        <gmap-autocomplete @place_changed="setStartPlace" ref="startPlace"></gmap-autocomplete>
      </div>

      <div class="col-md-6">
        <p>Haraya:</p>
        <gmap-autocomplete @place_changed="setEndPlace" ref="endPlace"></gmap-autocomplete>
      </div>

      <div class="col-md-6">
        <p>Yanacaq növü:</p>
        <div class="d-flex align-items-center">
          <label class="checkbox-wrapper">Dizel
            <input type="radio" value="1.00" v-model="fuel" @change="calcPrice">
            <span class="checkmark"></span>
          </label>
          <label class="checkbox-wrapper">Aİ-92
            <input type="radio" value="1.10" v-model="fuel" @change="calcPrice">
            <span class="checkmark"></span>
          </label>
          <label class="checkbox-wrapper">Premium
            <input type="radio" value="1.60" v-model="fuel" @change="calcPrice">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="col-md-6">
        <p>Yanacaq sərfiyyatı (100 km): {{ cons }} litr</p>
        <input type="range" min="4" max="30" step="0.10" v-model="cons" @input="calcPrice">
      </div>

      <div class="col-md-4">
        <div class="note">Məsafə: {{ distance | parseDistance }} km</div>
      </div>

      <div class="col-md-4">
        <div class="note">Vaxt: {{ duration | parseDuration }}</div>
      </div>

      <div class="col-md-4">
        <div class="note">Məbləğ: {{ price }} AZN</div>
      </div>

      <div class="col-12">
        <gmap-map
          ref="map"
          :center="center"
          :zoom="8"
          style="width: 100%; height: 400px;">
          <GmapMarker :position="start" />
          <GmapMarker :position="end" />
        </gmap-map>
      </div>

    </div>
  </div>
</template>

<script> 
  export default {
    data(){
      return {
        center: { lat: 40.4600818, lng: 48.3240209 },
        start: {
          lat: 0,
          lng: 0
        },
        end: {
          lat: 0,
          lng: 0
        },
        directionsService: null, 
        directionsDisplay: null,
        distance: 0,
        duration: 0,
        fuel: '1.10',
        cons: '10',
        price: 0
      }
    },
    methods: {
      setStartPlace(place) {
        this.start.lat = place.geometry.location.lat();
        this.start.lng = place.geometry.location.lng();
        this.calcRoute();
      },
      setEndPlace(place) {
        this.end.lat = place.geometry.location.lat();
        this.end.lng = place.geometry.location.lng();
        this.calcRoute();
      },
      calcPrice(){
        this.price = (this.distance / 100 * this.cons * this.fuel).toFixed(1);
      },
      calcRoute(){
        let self = this;

        let origin = new google.maps.LatLng(self.start);
        let destination = new google.maps.LatLng(self.end);
        
        if(self.directionsDisplay){
          self.directionsDisplay.setMap(null);
        }

        self.directionsService = new google.maps.DirectionsService();
        self.directionsDisplay = new google.maps.DirectionsRenderer({
          map: self.$refs.map.$mapObject, 
          suppressMarkers: true
        });

        let request = {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode.DRIVING
        };

        self.directionsService.route(request, function(result, status) {
          if (status == google.maps.DirectionsStatus.OK) {

            self.directionsDisplay.setDirections(result);

            let myRoute = result.routes[0].legs[0];
            self.distance = myRoute.distance.value / 1000;
            self.duration = myRoute.duration.value;

            self.calcPrice();

          } else {
            //console.log("please select place")
          }
        });

      }
    },
    filters: {
      parseDistance: function(value){
        return value.toFixed(0)
      },
      parseDuration: function(value){
        return Math.floor( value / 3600 ) + ' saat ' + (value % 3600 / 60).toFixed(0) + ' dəq.';
      }
    }
  }
</script>

<style scoped>

input[type="range"] {
  height: auto;
}
.note {
  font-weight: bold;
  text-align: center;
  margin: 0.5rem 0;
}
.vue-map-container {
  margin-top: 1rem;
}
.checkbox-wrapper {
  display: block;
  position: relative;
  padding-left: 2rem;
  margin-right: 1rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox-wrapper .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #ccc;
  border-radius: 100%;
}
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #ccc;
}
.checkbox-wrapper input:checked ~ .checkmark {
  background-color: #003366;
}
  
</style>


// WEBPACK FOOTER //
// src/components/calc/Road.vue